// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__pIy9g","languageSwitcher":"footer_languageSwitcher__yMtze","active":"footer_active__WUzOZ"};